/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { collectionStatusSchema } from './collection-status';
import { collectionTypeSchema } from './collection-type';

export const collectionRowSchema = z.object({
  id: z.number(),
  parentId: z.number().nullable(),
  title: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
  type: collectionTypeSchema,
  subject: z.string().nullable(),
  category: z.string().nullable(),
  difficulty: z.string().nullable(),
  year: z.number().nullable(),
  posterPath: z.string().nullable(),
  backdropPath: z.string().nullable(),
  thumbnailPath: z.string().nullable(),
  logoPath: z.string().nullable(),
  trailerPath: z.string().nullable(),
  genre: z.string().nullable(),
  rating: z.string().nullable(),
  tagline: z.string().nullable(),
  source: z.string().nullable(),
  publishedChallengesCount: z.number(),
  playableChallengesCount: z.number().optional(),
  isFeatured: z.number(),
  isPremium: z.number(),
  titleInPoster: z.number().default(0),
  status: collectionStatusSchema,
  sortOrder: z.number(),
  createdBy: z.string().nullable(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type ICollectionRow = z.infer<typeof collectionRowSchema>;
